import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Table, Typography, Button, Space, Tag } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

const { Link } = Typography;

export default function ApproveVenue() {
    const [data, setData] = useState([]);
    const { backUrl, authData } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;


    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/venues/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });
            setData(res.data.results || []);
        } catch (err) {
            console.error("Error fetching venues:", err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleApprove = async (id) => {
        try {
            await axios.post(
                `${backUrl}/api/emp/venues/${id}/set-status/`,
                { status: "Approved" },
                {
                    headers: { Authorization: `Bearer ${authData?.access}` },
                }
            );
            toast.success("Venue approved successfully!");
            fetchData();
        } catch (err) {
            toast.error("Failed to approve venue!");
            console.error(err);
        }
    };

    const handleDeny = async (id) => {
        try {
            await axios.post(
                `${backUrl}/api/emp/venues/${id}/set-status/`,
                { status: "Rejected" },
                {
                    headers: { Authorization: `Bearer ${authData?.access}` },
                }
            );
            toast.success("Venue denied!");
            fetchData();
        } catch (err) {
            toast.error("Failed to deny venue!");
            console.error(err);
        }
    };

    const columns = [
        {
            title: "Venue",
            dataIndex: "venue",
            key: "venue",
        },
        {
            title: "Map Location",
            dataIndex: "map_location_link",
            key: "map_location_link",
            render: (link) => (
                <Link className="p-2" href={link} target="_blank">
                    View on Map
                </Link>
            ),
        },
        {
            title: "Submitted By",
            dataIndex: ["submitted_by", "first_name"],
            key: "submitted_by",
        },
        {
            title: "Submission Date",
            dataIndex: "submission_date",
            key: "submission_date",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <p
                    style={{
                        color:
                            status === "Pending"
                                ? "orange"
                                : status === "Approved"
                                    ? "green"
                                    : "red",
                        fontWeight: "bold",
                        margin: 0,
                    }}
                >
                    {status === "Rejected" ? "Denied" : status}
                </p>
            ),
        },
        {
            title: "Approve",
            key: "approve",
            render: (_, record) => (
                <Button
                    // type="primary"
                    style={{ backgroundColor: '#0e497b', color: 'white' }}
                    icon={<CheckOutlined />}
                    onClick={() => handleApprove(record.id)}
                    disabled={record.status === "Approved"}
                >
                    Approve
                </Button>
            ),
        },
        {
            title: "Deny",
            key: "deny",
            render: (_, record) => (
                <Button
                    danger
                    icon={<CloseOutlined />}
                    onClick={() => handleDeny(record.id)}
                    disabled={record.status === "Rejected"}
                >
                    Deny
                </Button>
            ),
        },
    ];

    return (
        <div style={{ padding: 20 }}>
            {
                isMobile ? (
                    <center>
                        <p style={{ textTransform: 'uppercase' }}>Approve Venue</p>
                    </center>
                ) : (
                    <center>
                        <h3>Approve Venue</h3>
                    </center>
                )

            }

            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                bordered
                pagination={{ pageSize: 5 }}
                style={{ marginTop: 20, width: "100%" }}
                components={{
                    header: {
                        cell: (props) => (
                            <th
                                {...props}
                                style={{ backgroundColor: "#0e497b", color: "white" }}
                            >
                                {props.children}
                            </th>
                        ),
                    },
                }}
                scroll={{ x: "max-content" }}   
            />
        </div>
    );
}
